import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'primereact/slider';
import Analytics from '../../utils/Analytics';
import { SegmentEventTypes } from '../../data/tracking';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedSlider = props => {
	const { range = false, name, onChange, dataqa = 'common', ...rest } = props;
	const handleChangeEvent = e => {
		if (onChange) {
			e.name = name;
			onChange(e);
		}
	};

	const slideEndHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'slider',
				field_name_dataqa: `ui-slider-${dataqa}`,
				field_value: e.target?.value,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});
	};

	return (
		<div className="common-ui-slider" data-qa={`ui-slider-${dataqa}`}>
			<Slider
				range={range}
				onChange={handleChangeEvent}
				onSlideEnd={slideEndHandler}
				dataqa={`ui-slider-${dataqa}`}
				{...rest}
			/>
		</div>
	);
};

WrappedSlider.propTypes = {
	// (Optional) Used for slider between two numbers
	range: PropTypes.bool,
};

export const WrappedSliderWithLabel = LabelWrapper(WrappedSlider);
